import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Position, Toaster } from '@blueprintjs/core';

const NotificationToaster = Toaster.create({
  className: 'context-slider-toaster',
  position: Position.TOP
});

const Notification = (props) => {
  const notificationError = useSelector((state) => state.notification.error);
  const notificationWarning = useSelector(
    (state) => state.notification.warning
  );
  const notificationSuccess = useSelector(
    (state) => state.notification.success
  );
  useEffect(() => {
    if (notificationError) {
      NotificationToaster.show({
        message: notificationError,
        intent: 'danger'
      });
    }
  }, [notificationError]);
  useEffect(() => {
    if (notificationWarning) {
      NotificationToaster.show({
        message: notificationWarning,
        intent: 'warning'
      });
    }
  }, [notificationWarning]);
  useEffect(() => {
    if (notificationSuccess) {
      NotificationToaster.show({
        message: notificationSuccess,
        intent: 'success'
      });
    }
  }, [notificationSuccess]);
  return <div></div>;
};

Notification.propTypes = {};

export default Notification;
